import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [], // array of { module, actions: [] }
  loaded: false,
  loading: false,
  error: null,
};

const permissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    setPermissions(state, action) {
      state.list = Array.isArray(action.payload) ? action.payload : [];
      state.loaded = true;
      state.loading = false;
      state.error = null;
    },
    setPermissionsLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setPermissionsError(state, action) {
      state.loading = false;
      state.error = action.payload || "Failed to load permissions";
    },
    resetPermissions() {
      return initialState;
    },
  },
});

export const { setPermissions, setPermissionsLoading, setPermissionsError, resetPermissions } = permissionsSlice.actions;
export default permissionsSlice.reducer;

// Selector
export const selectPermissions = (state) => state.permissions?.list || [];

// Utility: build a predicate to check permissions
export const buildPermissionChecker = (permissions) => {
  const map = new Map();
  for (const p of permissions || []) {
    if (!p || !p.module) continue;
    map.set(String(p.module).toLowerCase(), new Set((p.actions || []).map((a) => String(a).toLowerCase())));
  }
  return (moduleName, actionName) => {
    if (!moduleName || !actionName) return false;
    const actions = map.get(String(moduleName).toLowerCase());
    return actions ? actions.has(String(actionName).toLowerCase()) : false;
  };
};

